import { BaseElement } from './base-element';
import { property } from 'lit/decorators.js';

/**
 * Validation result class
 */
export class Validation {
  isValid: boolean;
  validationMessage: string;

  constructor(isValid: boolean, validationMessage: string) {
    this.isValid = isValid;
    this.validationMessage = validationMessage;
  }

  /**
   * Validation Status
   * @return {Boolean}
   */
  get valid(): boolean {
    return this.isValid;
  }

  /**
   * Validation Message
   * @return {String}
   */
  get message(): string {
    return this.validationMessage;
  }

  toString(): string {
    return this.message;
  }
}

/**
 * Base Class for elements that provides name value pairs for Submission, e.g from forms
 */
export class SerializableElement extends BaseElement {
  public renderDefault(): unknown {
    throw new Error('Method not implemented.');
  }
  /**
   * Validation class reference
   */
  protected Validation = Validation;

  /**
   * Whether the element is required
   */
  @property({ type: Boolean })
  required = false;

  /**
   * The name of the element
   */
  @property({ type: String })
  name?: string;

  /**
   * The value of the element
   */
  @property({ type: Object })
  value?: any;

  /**
   * Get the name of the element
   * @throws {DOMException} Must be overridden by subclasses
   */
  getName(): string {
    throw new DOMException('Using "SerializableElement" must override "getName"');
  }

  /**
   * Get the value of the element
   * @throws {DOMException} Must be overridden by subclasses
   */
  getValue(): any {
    throw new DOMException('Using "SerializableElement" must override "getValue"');
  }

  /**
   * Validate the element
   * @throws {DOMException} Must be overridden by subclasses
   */
  validate(): Validation {
    throw new DOMException('Using "SerializableElement" must override "validate"');
  }

  /**
   * Handle invalid state
   * @throws {DOMException} Must be overridden by subclasses
   */
  invalid(): void {
    throw new DOMException('Using "SerializableElement" must override "invalid"');
  }

  /**
   * Handle valid state
   * @throws {DOMException} Must be overridden by subclasses
   */
  valid(): void {
    throw new DOMException('Using "SerializableElement" must override "valid"');
  }
}